module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__wrap"
  }, [_c('div', {
    staticClass: "footer__secondary"
  }, [_c('div', {
    staticClass: "footer__inner"
  }, [_c('div', {
    staticClass: "footer__region"
  }, [_c('span', [_vm._v("Region")]), _vm._v(" "), _c('select', {
    staticClass: "footer__region__select"
  }, [_c('option', {
    attrs: {
      "value": "en-US"
    }
  }, [_vm._v("USA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "zh-CN"
    }
  }, [_vm._v("China")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "in"
    }
  }, [_vm._v("India")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer__secondary__nav"
  }, [_c('span', [_vm._v("Copyright © 2017 IMooc All Rights Reserved.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://us.lemall.com/us/aboutUs.html"
    }
  }, [_vm._v("\n          About Us\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://us.lemall.com/us/termsofUse.html"
    }
  }, [_vm._v("\n          Terms & Conditions\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://us.lemall.com/us/privacyPolicy.html"
    }
  }, [_vm._v("\n          Privacy Policy\n        ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff8bef00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 85
// module chunks = 0